







































import { Component, Prop, Watch } from "vue-property-decorator";
import { CompanyModel, UserSearchModel } from "@/core/models";
import AppVue from "@/AppVue.vue";
import { CompanyService, UserService } from "@/core/services";

@Component({
  components: {},
})
export default class ClientSkillsConsultantUpdateCpt extends AppVue {
  @Prop() model: CompanyModel;

  hasEditedSkillsConsultant = false;
  isEditingSkillsConsultant = false;
  selectedSkillsConsultant = UserService.getNoneUser();
  loading = false;

  @Watch("model")
  onModelChanged(val: CompanyModel, oldVal: CompanyModel) {
    this.setNewSelectedSkillsConsultant(val.skillsConsultantId, val.skillsConsultant);
  }

  private clearSelectedSkillsConsultant() {
    this.selectedSkillsConsultant = UserService.getNoneUser();
    this.selectedSkillsConsultant.fullName = "";
  }

  private startEditingSkillsConsultant() {
    this.setNewSelectedSkillsConsultant(this.model.skillsConsultantId, this.model.skillsConsultant);
    this.isEditingSkillsConsultant = true;
  }

  private setNewSelectedSkillsConsultant(userId: number, fullName: string) {
    this.setSelectedSkillsConsultant({
      userId,
      fullName,
      email: "",
    });
  }

  private setSelectedSkillsConsultant(skillsConsultant: UserSearchModel) {
    this.selectedSkillsConsultant = skillsConsultant;
  }

  private selectSkillsConsultant(skillsConsultant: UserSearchModel) {
    this.setSelectedSkillsConsultant(skillsConsultant);
    this.hasEditedSkillsConsultant = true;
  }

  private async save() {
    this.loading = true;
    try {
      const model = await CompanyService.updateSkillsConsultant(this.model.id, this.selectedSkillsConsultant.userId);
      this.$emit("skills-consultant-updated", model);
    } catch (err) {
      this.notify("Error", "Something went wrong while saving Skills Consultant", "error");
    } finally {
      this.isEditingSkillsConsultant = false;
      this.hasEditedSkillsConsultant = false;
      this.loading = false;
    }
  }

  private cancel() {
    this.isEditingSkillsConsultant = false;
    this.hasEditedSkillsConsultant = false;
  }

  private async findSkillsConsultantAsync(queryString: string, cb: (result: UserSearchModel[]) => void) {
    if (!queryString || queryString.length <= 2) {
      cb([UserService.getNoneUser()]);
      return;
    }

    this.loading = true;
    try {
      const users = await UserService.searchImiUsersAsync(queryString);
      users.unshift(UserService.getNoneUser());
      cb(users);
    } catch (err) {
      this.notify("Error", "Something went wrong while searching Skills Consultant", "error");
    } finally {
      this.loading = false;
    }
  }
}
